import { NumberFieldDefinition } from "@src/core/engine/helpers/fieldDefinitions/getNumberDefinition";
import { useConvertedValueFormat } from "@src/shared/hooks/useConvertedValueFormat";
import { useUnitConversion } from "@src/shared/hooks/useUnitConversion";
import { useTranslation } from "react-i18next";

export function WaterInformationDescription({
  field,
}: {
  field: { valueSI: number } & NumberFieldDefinition;
}) {
  const { t } = useTranslation("settings");
  const formatValue = useConvertedValueFormat();
  const { convertToUserUnit } = useUnitConversion();

  return (
    <tr>
      <th scope="row">{t(field.translationKey)}</th>
      <td>
        {formatValue(
          field.valueSI.toString(),
          field.physicalType,
          convertToUserUnit,
        )}
      </td>
    </tr>
  );
}
